/* Betten-ABC: Beim Wechsel des Modells (Rubik Combined Listings) die gewählte Größe/Optionen beibehalten. */
(function () {
  if (window.gkModellGroesse) return;
  window.gkModellGroesse = true;

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/cm/g, '').replace(/\s+/g, '').replace(/×/g, 'x');
  }

  function currentOptions() {
    var res = {};
    document.querySelectorAll('variant-selects select[name^="options["], variant-radios input[name^="options["]:checked, variant-selects input[name^="options["]:checked').forEach(function (el) {
      var m = el.name.match(/^options\[(.+)\]$/);
      if (m && m[1] !== 'prefix' && el.value) res[m[1]] = el.value;
    });
    return res;
  }

  function findSwatch(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.tagName === 'A' && n.classList && n.classList.contains('rcl__swatch')) return n;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = findSwatch(e);
    if (!a || a.classList.contains('rcl__swatch--active')) return;
    var host = a.getRootNode && a.getRootNode().host;
    if (host && host.closest && host.closest('.card, .product-card, product-card, .card-wrapper')) return; // nur Produktseite
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) !== '/' || href.indexOf('/products/') !== 0) return;
    var opts = currentOptions();
    if (!Object.keys(opts).length) return;

    e.preventDefault();
    var base = href.split('?')[0].split('#')[0];
    var done = false;
    function go(url) { if (done) return; done = true; window.location.href = url; }
    var timer = setTimeout(function () { go(href); }, 2500);

    fetch(base + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        clearTimeout(timer);
        if (!p || !p.variants || !p.options) return go(href);
        var names = p.options.map(function (o) { return o.name || o; });
        var best = null, bestScore = -1;
        p.variants.forEach(function (v) {
          var score = 0;
          names.forEach(function (nm, i) {
            if (opts[nm] == null) return;
            if (norm(v['option' + (i + 1)]) === norm(opts[nm])) score += /gr(ö|oe)(ß|ss)e/i.test(nm) ? 10 : 2;
          });
          if (!score) return;
          if (v.available) score += 1;
          if (score > bestScore) { bestScore = score; best = v; }
        });
        go(best ? base + '?variant=' + best.id : href);
      })
      .catch(function () { clearTimeout(timer); go(href); });
  }, true);
})();
